// src/Utils/educamakerAccess.js
//
// EducaMaker por planes — P1 (popup de upsell para free).
// Plan maestro: docs/architecture/EDUCAMAKER_ACCESO_PLAN_MAESTRO.md (4.1).
//
// Fuente de verdad del plan: claim `plan_key` del JWT de acceso (lo inyecta
// el server via loadUserPlanContext en login/refresh). NO usar user.account:
// los profesores creados por instituciones de pago no lo tienen seteado.
//
// Regla de acceso: EducaMaker solo lo incluyen los planes con
// educamaker=true del catalogo (creator y enterprise; standard NO).
// Tokens SIN claim plan_key (usuarios legacy, admins) NUNCA se bloquean:
// mismo criterio de compatibilidad que checkPlanActive en el server.

import { jwtDecode } from "jwt-decode";
import { ENV } from "./constants";

export const EDUCAMAKER_PLAN_KEYS = ["creator", "enterprise"];

// Entrada real a EducaMaker (Spoke) — misma URL que abria el boton hasta hoy.
export const EDUCAMAKER_URL = "https://educa360.es/spoke/projects";

// CTAs del popup (URLs confirmadas contra WebPlanesK12 el 2026-07-23):
// /planes existe y #educamaker es el anchor de su seccion EducaMaker.
const UPSELL_UTM =
  "utm_source=portal&utm_medium=popup&utm_campaign=educamaker_upsell";
export const UPSELL_PRIMARY_URL = `https://planes.educa360.net/planes?${UPSELL_UTM}`;
export const UPSELL_SECONDARY_URL = `https://planes.educa360.net/planes?${UPSELL_UTM}#educamaker`;

export function getPlanKey(accessToken) {
  if (!accessToken) return null;
  try {
    return jwtDecode(accessToken)?.plan_key || null;
  } catch (err) {
    return null;
  }
}

// Plan efectivo para el gate. HALLAZGO PROD 2026-07-23: la institucion free
// paraguas apunta a un PlanEduca legacy SIN `key`, asi que el JWT de los
// free sale sin claim plan_key. Respaldo: user.account === "free" (lo setea
// el alta free y viaja en getMe). NO usar account para nada mas: los
// profesores de instituciones de pago no lo tienen (y ahi manda el claim).
export function getEffectivePlanKey(accessToken, userDoc) {
  const fromToken = getPlanKey(accessToken);
  if (fromToken) return fromToken;
  if (userDoc?.account === "free") return "free";
  return null;
}

export function hasEducamakerAccess(accessToken, userDoc) {
  const planKey = getEffectivePlanKey(accessToken, userDoc);
  if (!planKey) return true; // compat: sin plan conocido no se bloquea a nadie
  return EDUCAMAKER_PLAN_KEYS.includes(planKey);
}

// Tracking fire-and-forget contra el endpoint publico /landing-events
// (kinds educamaker_upsell_shown / educamaker_upsell_cta). Si el server
// aun no conoce el kind o falla la red, no afecta a la UX.
export function trackEducamakerUpsell(kind, { planKey, content } = {}) {
  try {
    const body = {
      kind,
      page: "/portal/teacher/educamaker",
      planKey: planKey || undefined,
      vertical: "k12",
      utm: {
        source: "portal",
        medium: "popup",
        campaign: "educamaker_upsell",
        ...(content ? { content } : {}),
      },
    };
    fetch(`${ENV.BASE_API}/landing-events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => null);
  } catch (err) {
    // el tracking jamas rompe la UX
  }
}
